import { track } from 'integrations/segment/instrumentation/Track';
import { FieldsType } from './types/types';

export const trackClickCheckout = (fields: FieldsType = {}): void =>
  track('track_click_checkout_cart_side_drawer', fields);

export const trackClickCloseCartSideCard = (fields: FieldsType = {}): void =>
  track('track_click_close_cart_side_drawer', fields);
